module.exports = __webpack_public_path__ + "img/20200713.1f979b49.png";